import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import { useQuickGuideStateStore } from '@/stores/quickGuideState';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useQuickGuideStateStore();

onMounted(async () => {
  try {
    await store.loadContent();
  } catch (err) {
    console.error('[App.vue] Failed to load content:', err);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})